<template>
  <section>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>
              {{ $t('attributes.add') + $t('attributes.traveler_type') }}
            </span>
          </a>
        </p>
      </div>
    </nav>
    <b-table
      :data="travelerTypes"
      :loading="loading"
      :row-class="row => row.main_price && 'has-background-danger-light'"
      :mobile-cards="false"
      narrowed
      bordered
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        numeric
        centered
        width="90"
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>
      <b-table-column
        field="main_price"
        :label="$t('attributes.main_price')"
        width="90"
        centered
        v-slot="props"
      >
        <b-radio
          v-model="main_traveler_type"
          :native-value="props.row.id"
          style="margin-top: 0.5rem; margin-right: 0;"
          @input="onSelectMainPrice"
        >
        </b-radio>
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        centered
        v-slot="props"
      >
        {{ props.row.traveler_type.name }}
      </b-table-column>
      <b-table-column
        field="display_name"
        :label="$t('attributes.display_name')"
        centered
        v-slot="props"
      >
        {{ props.row.traveler_type.display_name }}
      </b-table-column>
      <b-table-column
        field="type"
        :label="$t('attributes.traveler_bed_type')"
        centered
        v-slot="props"
      >
        {{ bedTypeName(props.row.traveler_type.type) }}
      </b-table-column>

      <b-table-column
        field="age_min"
        :label="$t('attributes.age_min')"
        numeric
        centered
        v-slot="props"
      >
        {{ props.row.traveler_type.age_min }}
      </b-table-column>

      <b-table-column
        field="age_max"
        :label="$t('attributes.age_max')"
        numeric
        centered
        v-slot="props"
      >
        {{ props.row.traveler_type.age_max }}
      </b-table-column>
      <b-table-column :width="140" label="功能" centered v-slot="props">
        <div class="buttons is-centered">
          <b-button
            type="is-info"
            size="is-small"
            @click.prevent.stop="onModify(props.row)"
          >
            {{ $t('attributes.modify') }}
          </b-button>
          <b-button
            type="is-danger"
            size="is-small"
            outlined
            @click.prevent.stop="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <traveler-type-form
        :travelerType="selectedTravelerType"
        :isCreate="isCreate"
        @send="onSend"
      />
    </b-modal>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import TravelerTypeForm from '@/components/catalogs/TravelerTypeForm'

export default {
  name: 'TravelerTypeList',
  components: { TravelerTypeForm },
  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      travelerTypes: [],
      main_traveler_type: null,

      sending: false,

      isFormModalActive: false,
      selectedTravelerType: null,
      isCreate: false
    }
  },
  watch: {
    catalog(newCatalog) {
      this.isCreate = false
      this.isFormModalActive = false
      this.selectedTravelerType = null
      this.loadTravelerTypesAsync(newCatalog.catalog_no)
    }
  },
  mounted() {
    this.loadTravelerTypesAsync(this.catalog.catalog_no)
  },
  methods: {
    async loadTravelerTypesAsync(catalog_no) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/${catalog_no}/traveler_type_list`
        const params = {
          catalog_no: catalog_no
        }
        const res = await this.axios.get(api, { params })
        this.travelerTypes = res.data.data
        const main_traveler = this.travelerTypes.find(t => t.main_price)
        this.main_traveler_type = main_traveler && main_traveler.id
      } catch (e) {
        this.travelerTypes = []
        this.main_traveler_type = null

        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    },
    onSelectMainPrice(id) {
      this.setMainPrice(id)
    },
    onAdd() {
      this.selectedTravelerType = {
        id: '',
        catalog_no: this.catalog.catalog_no,
        sort: 10,
        traveler_type_id: '',
        traveler_type: {}
      }
      this.isCreate = true
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedTravelerType = item
      this.isCreate = false
      this.isFormModalActive = true
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete_with_name', {
          name: item.traveler_type.name
        }),
        focusOn: 'cancel',
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    async setMainPrice(id) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/set/traveler_type_main_price`
        const params = {
          catalog_no: this.catalog.catalog_no,
          id: id
        }
        await this.axios.put(api, params)

        notifyService.success(this.$t('attributes.update_main_price_succeed'))
        await this.loadTravelerTypesAsync(this.catalog.catalog_no)
      } catch (e) {
        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    },
    async deleteItem(item) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/delete/traveler_type`
        const params = {
          id: item.id
        }
        await this.axios.delete(api, { params })

        notifyService.success(this.$t('attributes.delete_succeed'))
        await this.loadTravelerTypesAsync(this.catalog.catalog_no)
      } catch (e) {
        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    },
    onSend(item) {
      if (this.isCreate) {
        this.onCreate(item)
      } else {
        this.onUpdate(item)
      }
    },
    async onCreate(item) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/create/traveler_type`
        await this.axios.post(api, item)

        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadTravelerTypesAsync(this.catalog.catalog_no)
        this.isFormModalActive = false
      } catch (e) {
        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    },
    async onUpdate(item) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/update/traveler_type`
        await this.axios.put(api, item)

        notifyService.success(this.$t('attributes.update_succeed'))
        await this.loadTravelerTypesAsync(this.catalog.catalog_no)
        this.isFormModalActive = false
      } catch (e) {
        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
